import axios from "axios";
import React, { useState, useEffect } from "react";
import {
  VictoryChart,
  VictoryBar,
  VictoryStack,
  VictoryAxis,
  VictoryTooltip,
} from "victory";

export const StackedBarChartForCommerciale = () => {
  const [Data, setData] = useState(null);

  const formatData = (data) => {
    return {
      actualStock: data.map((item) => ({
        x: item.name,
        y: item.stock,
        label: `Actual Stock: ${item.stock}`,
      })),
      acceptedTransactions: data.map((item) => ({
        x: item.name,
        y: item.accepted,
        label: `Accepted: ${item.accepted}`,
      })),
      pendingTransactions: data.map((item) => ({
        x: item.name,
        y: item.pending,
        label: `Pending: ${item.pending}`,
      })),
    };
  };

  const handleFetchData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/getDetailedCommerciaux`,
        { withCredentials: true }
      );
      setData(formatData(response?.data));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    handleFetchData();
  }, []);

  // Mock data for commercials
  const data = {
    actualStock: [
      { x: "Commercial test", y: 50, label: "Actual Stock: 50" },
      { x: "Slim Saiidi", y: 40, label: "Actual Stock: 40" },
      { x: "Zied Belgasmi", y: 30, label: "Actual Stock: 30" },
      { x: "Louay Smida", y: 30, label: "Actual Stock: 30" },
    ],
    acceptedTransactions: [
      { x: "Commercial test", y: 20, label: "Accepted: 20" },
      { x: "Slim Saiidi", y: 25, label: "Accepted: 25" },
      { x: "Zied Belgasmi", y: 15, label: "Accepted: 15" },
      { x: "Louay Smida", y: 15, label: "Accepted: 15" },
    ],
    pendingTransactions: [
      { x: "Commercial test", y: 10, label: "Pending: 10" },
      { x: "Slim Saiidi", y: 15, label: "Pending: 15" },
      { x: "Zied Belgasmi", y: 20, label: "Pending: 20" },
      { x: "Louay Smida", y: 20, label: "Pending: 20" },
    ],
  };

  return (
    <div className="flex flex-col w-full dak:bg-white  dark-text-white bg-white border border-gray-200  shadow-sm dark:border-white dark:bg-gray-800">
      <h1 className="p-2 text-xl font-bold text-gray-900 dark:text-white">
        Etat de stock des commerciales
      </h1>
      <div className="w-full flex h-full px-4 ">
        <VictoryChart width={800} height={400} domainPadding={{ x: 50, y: 20 }}>
          {/* X-Axis */}
          <VictoryAxis
            style={{
              axis: { stroke: "#ccc" },
              tickLabels: { fontSize: 12, fill: "#666" },
            }}
          />
          {/* Y-Axis */}
          <VictoryAxis
            dependentAxis
            style={{
              axis: { stroke: "#ccc" },
              grid: { stroke: "#ccc", strokeDasharray: "8" }, // Grid background
              tickLabels: { fontSize: 12, fill: "#666" },
            }}
          />
          <VictoryStack>
            {/* Actual Stock */}
            <VictoryBar
              barWidth={20}
              data={Data?.actualStock}
              style={{
                data: { fill: "#4CAF50" }, // Green for actual stock
              }}
              labels={({ datum }) => datum.label}
              labelComponent={<VictoryTooltip />}
            />
            {/* Accepted Transactions */}
            {/* <VictoryBar
              barWidth={17}
              data={Data.acceptedTransactions}
              style={{
                data: { fill: "#2196F3" }, // Blue for accepted transactions
              }}
              labels={({ datum }) => datum.label}
              labelComponent={<VictoryTooltip />}
            /> */}
            {/* Pending Transactions */}
            <VictoryBar
              barWidth={20}
              data={Data?.pendingTransactions}
              style={{
                data: { fill: "#FF9800" }, // Orange for pending transactions
              }}
              labels={({ datum }) => datum.label}
              labelComponent={<VictoryTooltip />}
            />
          </VictoryStack>
        </VictoryChart>
      </div>
    </div>
  );
};
